import { useNavigate } from "react-router-dom";

export default function SeeMoreCard({ link }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(link)}
      className="
        px-3 py-2
        bg-[#1C1B19]
        rounded-[10px]
        border border-dashed border-[#353530]
        transition-all duration-300
        shadow-black/25 shadow-xl
        font-sora text-[11px]
      "
    >
      See more
    </button>
  );
}
